export default {
  ADDED_SET_ITEM: 'PE_ADDED_SET_ITEM',
  ADD_CONTRIB_COUNT: 'PE_ADD_CONTRIB_COUNT',
  ADD_EXTERNAL_PROJECT: 'PE_ADD_EXTERNAL_PROJECT',
  ADD_SET_ITEM: 'PE_ADD_SET_ITEM',
  BACKEND_ERROR: 'PE_BACKEND_ERROR',
  BACKEND_SYNC: 'PE_BACKEND_SYNC',
  CHECK_VALIDATION: 'PE_CHECK_VALIDATION',
  EDIT_SET_ITEM: 'PE_EDIT_SET_ITEM',
  FETCH_SECTION: 'PE_FETCH_SECTION',
  FETCH_SECTION_ROOT: 'PE_FETCH_SECTION_ROOT',
  FETCH_SET_ITEMS: 'PE_FETCH_SET_ITEMS',
  MOVED_SET_ITEM: 'PE_MOVED_SET_ITEM',
  REMOVED_SET_ITEM: 'PE_REMOVED_SET_ITEM',
  REMOVE_EXTERNAL_PROJECT: 'PE_REMOVE_EXTERNAL_PROJECT',
  REMOVE_SET_ITEM: 'PE_REMOVE_SET_ITEM',
  REMOVE_SET_ITEM_FAIL: 'PE_REMOVE_SET_ITEM_FAIL',
  RESET_PROJECT: 'PE_RESET_PROJECT',
  SAVE_FIELDS: 'PE_SAVE_FIELDS',
  SAVING: 'PE_SAVING',
  SET_EXTERNAL_PROJECT: 'PE_SET_EXTERNAL_PROJECT',
  SET_FIELD_REQUIRED_ERROR: 'PE_SET_FIELD_REQUIRED_ERROR',
  SET_FIRST_SECTION_ID: 'PE_SET_FIRST_SECTION_ID',
  SET_NEW_PROJECT: 'PE_SET_NEW_PROJECT',
  SET_PARENT_PROJECT: 'PE_SET_PARENT_PROJECT',
  SET_PROJECT_ID: 'PE_SET_PROJECT_ID',
  SET_SECTION_FETCHED: 'PE_SET_SECTION_FETCHED',
  SHOW_REQUIRED: 'PE_SHOW_REQUIRED',
  TOGGLE_PRIVACY: 'PE_TOGGLE_PRIVACY',
  TOUCH_SECTION: 'PE_TOUCH_SECTION',
  UPDATE_LAST_SAVED: 'PE_UPDATE_LAST_SAVED',
  UPDATE_PAGINATION: 'PE_UPDATE_PAGINATION',
  VALIDATION_SYNC: 'PE_VALIDATION_SYNC',
}
